import styled from "@emotion/styled";
import { Typography } from "@mui/material";
import Paper from "@mui/material/Paper";
import { DataGrid } from "@mui/x-data-grid";
import { COLOR_BLACK, COLOR_GREY_2, COLOR_GREY_9 } from "shared/theme/colors";
import FlexCenter from "../Layout/components/FlexCenter";

export const StyledDataGrid = styled(DataGrid)`
  border: none;
  cursor: pointer;

  & .MuiDataGrid-columnHeaderTitle {
    color: ${COLOR_BLACK};
    font-weight: 700;
  }

  & .MuiDataGrid-columnSeparator {
    display: none;
  }

  & .MuiDataGrid-iconButtonContainer {
    margin-left: 0.25rem;
  }

  .MuiDataGrid-virtualScroller {
    min-height: 120px;
  }

  & .MuiDataGrid-columnHeader,
  .MuiDataGrid-cell {
    padding: 0.5rem;
    white-space: normal;
    outline: none;

    &:focus,
    &:focus-within {
      outline: none;
    }
  }
`;

export const StyledEmptyWrapper = styled(FlexCenter)`
  margin-top: 1rem;
  background-color: ${COLOR_GREY_2};
  height: 80px;
  align-items: center;
  justify-content: center;
  text-align: center;
  border-radius: 1rem;
`;

export const StyledPaper = styled(Paper)`
  box-shadow: none;
`;

export const StyledTypography = styled(Typography)`
  color: ${COLOR_GREY_9};
  font-size: 0.875rem;
  line-height: 1.875rem;
`;
